export default __webpack_public_path__ + "static/img-finish-products-cf9c6af99b05ba6f75742ed249eedf2d.webp";